/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Accueil',
	homePageTabsLabel: 'Contenu principal',
	myContent: 'Mon contenu',
	teamContent: 'Contenu de l\'équipe',
	folder: 'Dossier',
	files: 'Fichiers',
	actionMenu: 'Menu Action',
	myFolder: 'Mes dossiers',

	emptyFolderNoContent: 'Aucun contenu',

	//EmptyStates
	emptyRecentTitle: 'Vous n\'avez affiché aucun contenu récemment.',
	emptyStateTitle: 'Commencez par ajouter des données',
	emptyStateBody: 'Cliquez sur Transférer les données ci-dessus ou glissez-déposez pour transférer les données.',
	emptySearchResultTitle: 'Votre recherche n\'a renvoyé aucun résultat.',
	emptyPortalTitle: 'Aucun portail',
	emptyPortalBody: 'Vous n\'avez actuellement pas de portail.',
	emptyWsProjectTitle: 'Commencez par créer un bloc-notes dans Watson Studio.',
	emptyWsProjectBody: 'Lorsque vous retournerez dans Cognos Analytics, votre bloc-notes apparaîtra ici.',
	emptyFilteredResultTitle: 'Les filtres appliqués n\'ont renvoyé aucun résultat.',
	emptyDialogViewTitle: 'Aucun élément',
	removeFromRecents: 'Retirer des éléments récents',

	// Welcome Banner
	welcomeBannerGreeting: 'Bonjour, bienvenue dans Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson offre aux utilisateurs des analyses en libre-service basées sur l\'intelligence artificielle. Découvrez comment la préparation, la reconnaissance et la visualisation automatisées des données peuvent aboutir à des décisions plus sûres.',
	welcomeBannerDescription_trialUser: 'Vous pouvez commencer à utiliser immédiatement le produit en visionnant notre vidéo de présentation, en effectuant la visite guidée du produit et en affichant l\'onglet Mise en route.',
	takeTourButtonLabel: 'Effectuer une visite guidée du produit',
	watchVideoButtonLabel: 'Visionner la vidéo',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Voulez-vous vraiment désactiver la bannière de bienvenue de votre page d\'accueil ? Vous pouvez la réactiver à tout moment dans Profil et paramètres > Paramètres > Général. ',
	hideWelcomeBannerTitle: 'Désactiver la bannière de bienvenue',
	ok: 'OK',
	cancel: 'Annuler',
	warn: 'Avertissement',
	//howto video dialog
	modal_how_title: 'Visionner une présentation de Cognos Analytics',
	modal_overview_title: 'Visionner une présentation de Cognos Analytics',
	modal_how_play: 'Lire la vidéo',
	modal_how_video_title_overview: 'Aperçu',
	modal_how_video_title_getStarted: 'Initiation à la version 11.2',
	modal_how_video_title_newUI: 'Bienvenue dans la nouvelle expérience Cognos',
	modal_how_video_title_dataModule: 'Présentation des modules de données',
	modal_how_video_title_explore: 'Présentation de l\'exploration de données',
	modal_how_video_title_dashboard: 'Présentation des tableaux de bord interactifs',
	modal_how_video_title_reporting: 'Présentation de la génération de rapports',
	modal_how_video_title_mobile: 'La puissance de Cognos au creux de votre main',

	// Toolbar
	search: 'Rechercher',
	addFolder: 'Ajouter un dossier',
	addLink: 'Ajouter un lien',
	filter: 'Filtre',
	sort: 'Trier',
	settings: 'Paramètres',
	tilesView: 'Vue Mosaïque',
	listView: 'Vue de liste',
	columnView: 'Vue Colonne',
	backToSearch: 'Retour aux résultats de recherche',

	// Toolbar Actions
	sortBy: 'Trier par',
	sortOrder: 'Ordonner',
	name: 'Nom',
	modifiedTime: 'Modifié',
	type: 'Type',
	ascending: 'Croissant',
	descending: 'Décroissant',
	resetSort: 'Réinitialiser le tri',

	filterType: 'Type',
	filterModificationTime: 'Modifié',
	all: 'Toutes',
	today: 'Aujourd\'hui',
	yesterday: 'Hier',
	pastWeek: 'Semaine dernière',
	pastMonth: 'Mois dernier',
	resetFilters: 'Réinitialiser les filtres',
	resultLimit: 'Limite de résultats',

	filterSearchPlaceHolder: 'Filtrer par mots clés',

	resetFilterTag: 'Cliquez sur X pour réinitialiser les filtres.',
	filterTagToolTip: 'Filtres appliqués : %{appliedFilters}.',

	folderName: 'Nom du dossier',
	addAFolder: 'Ajouter un dossier',
	add: 'Ajouter',
	error: 'Erreur',
	newFolderDefaultName: 'Nouveau dossier',
	toastCreateNewFolder: 'Le dossier %{nameOfFolder} a été créé dans %{tabName}.',
	folderAdded: 'Dossier ajouté',
	refresh: 'Actualiser',
	openFolder: 'Ouvrir le dossier',

	addAUrl: 'Ajouter une URL',
	linkName: 'Nom de l\'URL',
	linkNamePlaceholder: 'Ajouter un nom d\'URL',
	linkDescription: 'Description (facultatif)',
	linkDescriptionPlaceholder: 'Ajouter une description',
	linkUri: 'URL',
	linkUriPlaceholder: 'Ajouter une URL qui utilise un domaine acceptable',
	acceptableDomains: 'Domaines acceptables',
	viewAcceptableDomains: 'Afficher les domaines acceptables',
	mandatoryField: 'Zone obligatoire',
	linkAdded: 'URL ajoutée',
	toastCreateNewLink: '%{nameOfLink} a été ajouté à %{tabName}.',
	noEntries: 'La liste de domaines acceptables ne comporte aucune entrée. Veuillez contacter l\'administrateur.',
	unacceptableDomain: 'Votre URL utilise un domaine non valide. Cliquez sur \'Afficher les domaines acceptables\' pour afficher une liste de domaines à utiliser.',

	compact: 'Compact',
	short: 'Abrégé',
	default: 'Par défaut',
	rowSize: 'Taille de ligne',

	// GroupyByTypes
	folders: 'Dossiers',
	reports: 'Rapports',
	dashboards: 'Tableaux de bord',
	data: 'Données',
	packages: 'Packs',
	explorations: 'Explorations',
	stories: 'Histoires',
	notebooks: 'Blocs-notes',
	others: 'Autre',

	// Error Messages
	itemsOverLimit: 'Le nom indiqué "%{itemName}" a dépassé la limite maximale (20). Indiquez un nom différent pour continuer.',
	errorMessageLengthFolderName: 'Entrez un nom de dossier qui ne dépasse pas 255 caractères.',
	errorMessageLengthLinkName: 'Entrez un nom de lien qui ne dépasse pas 255 caractères.',
	toastLaunchPerspectiveError: 'Impossible d\'ouvrir %{objectType}.',
	errorNoAccessTitle: 'Hmm, il semblerait que vous n\'ayez pas accès à ce contenu',
	errorNoAccessBody: 'Contactez votre administrateur ou reportez-vous au lien suivant :',
	errorEnableExternalContent: 'Activation du contenu externe',

	//TableHeader
	lastAccessed: 'Dernier accès',
	location: 'Emplacement',
	tenant: 'Locataire',

	// GetStartedTab
	getStartedLabel: 'Etre opérationnel dans IBM Cognos Analytics',
	learningHowToLabel: 'Ressources d\'apprentissage',
	learningHowToDescription: 'Développez vos connaissances et obtenez de l\'aide en rejoignant la communauté, en lisant les documentations et en visionnant des vidéos.',
	learningHowToActionLabel: 'Lancer le panneau d\'apprentissage',
	howToVideosLabel: 'Vidéos tutoriels',
	howToVideosDescription: 'Apprenez à utiliser IBM Cognos Analytics et commencez à mieux comprendre vos données.',
	howToVideosActionLabel: 'Visionner des vidéos',
	acceleratorCatalogLabel: 'Catalogue d\'accélérateurs',
	acceleratorCatalogDescription: 'Parcourez un catalogue régulièrement enrichi qui présente des utilisations dans des secteurs d\'activité, des guides des meilleures pratiques, des visualisations personnalisées, etc.',
	acceleratorCatalogActionLabel: 'Parcourir le catalogue',
	sampleSectionTitle: 'Exemples',
	sampleSectionDescription: 'Découvrez des exemples qui présentent tout ce que Cognos Analytics peut offrir.',
	// Samples Section
	createDashboardSampleTitle: 'Comment créer votre premier tableau de bord',
	createDashboardSampleDescription: 'Découvrez l\'analyse avec Cognos Dashboards.',
	nlaSampleTitle: 'Exemple de rapport',
	nlaSampleDescription: 'Explorez les possibilités avec Cognos Analytics Reports avec cet exemple qui analyse l\'activité des adhérents possédant une carte de fidélité de fin d\'année.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Développez votre bibliothèque de visualisations avec des visualisations personnalisées, telles que le graphique Sankey.',
	viewAllSamplesActionLabel: 'Afficher tous les exemples',
	byFeatureTitle: 'Par fonction',
	byFeatureDescription: 'Parcourir les exemples par fonction, comme la fonctionnalité de base, les contrôles personnalisés, les extensions, les blocs-notes et les dates relatives.',
	byIndustryTitle: 'Par secteur',
	byIndustryDescription: 'Parcourir les exemples par secteur, comme l\'automobile, la banque, etc.',
	// SamplesTab
	sampleTabTitle: 'Laissez-vous inspirer par nos exemples préconfigurés',
	sampleTabLabel: 'Pour plus d\'exemples et d\'extensions d\'IBM, de partenaires et de clients, rendez-vous dans le catalogue d\'accélérateurs',

	// quickLaunch
	quickLaunchLabel: 'Lancement rapide',
	expand: 'Développer',
	collapse: 'Réduire',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Commencez par choisir ce que vous souhaitez créer.',

	// contentPageView
	contentPageTitleLabel: 'Contenu',
	uploadFile: 'Transférer les données',
	new: 'Nouveau',
	create: 'Créer',
	more: 'Plus',

	// open dialog
	selectDataSourcesToAdd: 'Sélectionnez une ou plusieurs sources de données à ajouter.',
	openDialogDefaultTitle: 'Ouvrir',

	// save dialog
	save: 'Sauvegarder',
	saveAs: 'Sauvegarder sous',
	saving: 'Sauvegarde...',
	selectedDestination: 'Destination sélectionnée : %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' existe déjà avec un type différent. Veuillez choisir un autre nom.',
	confirmOverwriteTitle: 'Confirmer le remplacement des données existantes',
	confirmOverwriteMsg: 'Le fichier \'%{nameOfFile}\' existe déjà. Voulez-vous remplacer ses données par celles du fichier sélectionné ?',

	// copy move dialog
	copy: 'Copier',
	move: 'Déplacer',
	copyOrMove: 'Copier ou déplacer : ',
	copyOnly: 'Copier ',
	createShortcut: 'Créer un raccourci',
	createShortcutDialogTitle: 'Création de raccourci : ',

	// External asset types
	wsProject: 'Projet Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pack',
	dataModule: 'Module de données',
	exploration: 'Exploration',
	mode: 'Mode',
	live: 'En direct',
	snapshot: 'Instantané',
	noSnapshotsFound: 'Aucun instantané n\'a été trouvé',
	uploadedFile: 'Fichier transféré',
	fileUpload: 'Transférer les données',
	dataSetEx: 'Ensemble de données',
	externalRepository: 'Référentiel externe',
	queryMode: 'Mode requête',
	queryModeCompatible: 'Compatible',
	queryModeDynamic: 'Dynamique',
	report: 'Rapport',
	activeReport: 'Rapport actif',
	query: 'Requête',
	analysis: 'Analyse',
	dashboard: 'Tableau de bord',
	dashboardTemplate: 'Modèle de tableau de bord',
	jupyterNotebook: 'Bloc-notes',
	wsNotebook: 'Bloc-notes Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Histoire',
	workspace: 'Espace de travail',
	pagelet: 'Page',
	content: 'Contenu',
	directory: 'Espaces-noms',
	dataSet: 'Ensemble de données',
	powerPlayCube: 'Cube PowerPlay',
	powerPlayReport: 'Rapport PowerPlay',
	powerPlay8Report: 'Rapport PowerPlay',
	setPowerPlay8ReportOptions: 'Définir les options de rapport PowerPlay',
	powerPlay8ReportView: 'Vue de rapport PowerPlay',
	reportTemplate: 'Modèle de rapport',
	packageConfigurations: 'Configuration du pack',
	agent: 'Agent',
	agentDefinition: 'Définition d\'agent',
	agentDefinitionView: 'Vue d\'agent',
	dataMovementTask: 'Tâche de transfert des données',
	dataMovementTaskAlias: 'Alias de la tâche de transfert des données',
	document: 'Document',
	DocumentRetention: 'Propriétés du document',
	jobDefinition: 'Définition du travail',
	job: 'Travail',
	jobs: 'Travaux',
	metricsDataSourceETLTask: 'Tâche ETL source des données d\'indicateurs',
	metricsExportTask: 'Tâche d\'exportation des indicateurs',
	metricsFileImportTask: 'Tâche d\'importation des fichiers d\'indicateurs',
	metricsMaintenanceTask: 'Tâche de maintenance des indicateurs',
	planningTask: 'Tâche de planification',
	shortcut: 'Raccourci',
	shortcuts: 'Raccourcis',
	URL: 'URL',
	launchable: 'Lançable',
	dataSetFolder: 'Dossier d\'ensembles de données',
	ViewAccessibleLabel: 'Afficher %{label}',
	overrideReportOptions: 'Remplacer les options de rapport par défaut',
	formats: 'Formats',
	saveReport: 'Sauvegarder le rapport',
	reportView: 'Vue du rapport',
	reportviews: 'Vues de rapport',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Données Excel',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Rôle',
	namespace: 'Espace de nom',
	namespaceFolder: 'Dossier des espaces de noms',
	adminFolder: 'Dossier d\'administrateur',
	//Details
	details: 'Détails',
	open: 'Ouvrir',
	created: 'Créé',
	modified: 'Modifié',
	owner: 'Propriétaire',
	dataSource: 'Source de données',
	share: 'Partager',
	addToFavorites: 'Ajouter aux favoris',
	properties: 'Propriétés',
	detailsEmptyStateBody: 'Sélectionner un élément pour afficher ses détails',
	editNameAndDescription: 'Editer le nom et la description',
	none: 'Aucun',
	setPdfOptions: 'Définir les options PDF',
	runOptions: 'Options d\'exécution',

	//rename dialog
	nameInvalid: 'Le nom n\'est pas valide',
	namePlaceholder: 'Entrez un nom',
	description: 'Description',
	descriptionInvalid: 'La description ne doit pas dépasser 350 caractères.',
	descriptionPlaceholder: 'Entrez une description',
	errorMessageApostropheError: 'Entrez un nom de fichier qui ne contient pas les caractères \' et "',
	renameCollisionError: '%{name} existe déjà. Essayez un autre nom.',
	unknownRenameError: 'Le renommage de l\'élément a échoué. Pour obtenir de l\'aide supplémentaire, contactez votre administrateur.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Impossible d\'ouvrir le dossier indiqué.',

	//Upload
	uploadToFolder: "Transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> et lancer %{launchAction}",
	quickUpload: "Transfert rapide",
	quickUploadAndLaunch: "Glissez-déposez les fichiers à transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> et à ouvrir dans l'un des espaces suivants :",
	unsupportedFilesSingle: "%{files} n'a pas été transféré car il n'est pas valide pour la fonction Lancement rapide.",
	unsupportedFilesMultiple: "Les fichiers n'ont pas pu être transférés car tous les fichiers que vous sélectionnez doivent être valides pour utiliser le Lancement rapide.",
	unsupportedFilesSingleInvalid: "%{files} n'est pas valide.",
	unsupportedFilesMultipleInvalid: "%{files} ne sont pas valides.",
	supportedFileTypes: "Seuls les types de fichier suivants sont autorisés : %{extensions}.",
	uploadDragAndDrop: "Glisser-déposer",
	uploadDragAndDropMessage: "Glissez-déposez votre fichier ici pour le transférer dans <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Les critères de recherche \'%{searchTerm}\' ont été sauvegardés.',
	searchWasntSaved: 'Les critères de recherche \'%{searchTerm}\' n\'ont pas été sauvegardés.',
	searchSuggestions: 'Suggestions',
	savedSearch: 'Recherches sauvegardées',
	searchWasDeleted: 'Les critères de recherche \'%{searchTerm}\' ont été supprimés.',
	searchWasntDeleted: 'Les critères de recherche \'%{searchTerm}\' n\'ont pas été supprimés.',
	savedBarTitle: 'Rechercher dans Cognos Analytics',
	searchContentPageTitle: 'Rechercher',
	searchContentPageTitleLabel: 'Affichage des résultats de \'%{searchTerm}\'',
	showingSearchRsult: 'Affichage des éléments %{resultCount}',
	saveSearch: 'Sauvegarder la recherche',
	saveTenSearches: 'Vous pouvez sauvegarder 10 recherches.',
	deleteASearch: 'Supprimez-en une pour en sauvegarder une autre.',
	close: 'Fermer',
	allContent: 'Tout le contenu',
	searchResultIn: 'Résultats de la recherche dans : ',
	//recent view
	recents: 'Récent',
	noAccessRecent: 'Pas d\'accès',
	noAccessRecentMsg: 'Vous n\'avez pas accès à cet actif. Il a peut-être été désactivé ou supprimé, ou vos droits ont peut-être été réduits. Vérifiez l\'état de l\'actif à son emplacement source prévu. Vous pouvez supprimer l\'actif de vos éléments récents en cliquant sur OK.',
	noAccessMsg: 'Vous n\'avez pas accès à cet actif. Il a peut-être été désactivé ou supprimé, ou vos droits ont peut-être été réduits.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} éléments sélectionnés',
	itemSelected: '%{nameOfSelection} élément sélectionné',

	//properties
	general: 'Général',
	schedule: 'Planification',
	permission: 'Droits',
	capabilities: 'Fonctionnalités',
	propertiesTabsLabel: 'Contenu des propriétés',
	searchPath: 'Chemin de la recherche',
	id: 'ID',
	language: 'Langue',
	setLanguage: 'Définir le langage',
	entryOptions: 'Options d\'entrée',
	setPackage: 'Définir le package ou le module',
	sourcePackage: 'Pack ou module de données source',
	associatedSourceAgent: 'Pack source',
	setAssociatedSourceAgent: 'Définir le package',
	sourceAgent: 'Agent source',
	setSourceAgent: 'Définir l\'agent source',
	setCapabilities: 'Définir les fonctionnalités',
	disableEntry: 'Désactiver cette entrée',
	hideEntry: 'Masquer cette entrée',
	permissions: 'Autorisations',
	promptForValues: 'Demander des valeurs',
	yes: 'Oui',
	no: 'Non',
	setValues: 'Définir des valeurs',
	moreOptions: 'Plus d\'options',
	reportFormat: 'Format de rapport',
	enableAccessibilitySupport: 'Activer le support d\'accessibilité',
	displayOfRunHistory: 'Afficher l\'historique d\'exécution',
	occurrences: 'Occurrences',
	days: 'Jour(s)',
	months: 'Mois',
	displayOfReportOutputVersions: 'Affichage de la version de sortie de rapport',
	defaultDisplayOfPortalAction: 'Action de portail par défaut',
	viewMostRecentReport: 'Afficher le rapport le plus récent',
	runTheReport: 'Exécuter le rapport',
	openWithReportStudio: 'Ouvrir avec Report Studio',
	rowsPerPageInHtmlReports: 'Lignes par page dans les rapports HTML',
	enableSelectionBasedInteractivity: 'Activer l\'interactivité basée sur la sélection',
	enableAlertsAboutNewVersions: 'Activer les alertes sur les nouvelles versions',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Activer les fonctions utilisateur avancées dans les versions de sortie enregistrées',
	enableCommentsInSavedOutputVersions: 'Activer les commentaires dans les versions de sortie enregistrées',
	run: 'Exécuter',
	runWithUsersCredentials: 'Avec les données d\'identification de l\'utilisateur',
	runWithOwnerCapabilities: 'Avec la fonctionnalité propriétaire',
	runAsOwner: 'En tant que %{ownerName}',
	actionLabelOn: 'Activé',
	actionLabelOff: 'Désactivé',
	openReport: 'Editer',
	openAnalysis: 'Ouvrir avec Analysis Studio',
	openQuery: 'Ouvrir avec Query Studio',
	openPowerPlay8Report: 'Ouvrir avec PowerPlay Studio',
	openInteractiveReport: 'Editer',
	read: 'Lecture',
	write: 'Ecriture',
	execute: 'Exécuter',
	setPolicy: 'Définir la stratégie',
	full: 'Complet',
	traverse: 'Traverser',
	grant: 'Accorder',
	deny: 'Refuser',
	permissionCustom: 'Personnalisé',
	permissionDetailsColumnAccess: 'Accès',
	permissionDetailsColumnPermission: 'Droit',
	permissionDetailsColumnAction: 'Action',
	permissionSetAccess: 'Définir l\'accès',
	permissionRead: 'Lecture',
	permissionRun: 'Exécuter',
	permissionWrite: 'Ecriture',
	permissionFull: 'Complet',
	unavailable: 'Non disponible',
	unkownSource: 'Inconnu, ouvrez le rapport pour plus de détails',
	tenantSettings: 'Paramètres du locataire',
	tenantSet: 'Locataire mis à jour',
	tenantSetError: 'Erreur lors de la définition du locataire',
	tenantClear: 'Locataire effacé',
	tenantClearError: 'Erreur lors de l\'effacement du locataire',
	shortcutTo: 'Raccourci vers',
	sourceReport: 'Rapport source',
	setSourceReport: 'Définir le rapport source',
	setSourceLocation: 'Définir l\'emplacement %{itemName} source',
	linkPackageOrModule: 'Lier %{itemName} à un package ou à un module de données',
	linkPackage: 'Lier %{itemName} à un package',
	externalRepositories: 'Référentiels externes',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} ko',
	sizeMegaByte: '%{value} Mo',
	sizeGigaByte: '%{value} Go',
	sizeTeraByte: '%{value} To',
	sizePetaByte: '%{value} Po',
	refreshedDatetime: 'Heure actualisée',
	size: 'Taille',
	tenantsWarningMessage: 'Si vous changez le locataire d\'une entrée, vous changez également le locataire des entrées enfant.',
	confirmClearTenantText: 'Si vous changez la valeur sur \'None\', d\'autres locataires pourront accéder au contenu. Cliquez sur OK pour rendre l\'entrée publique ou sur Annuler pour conserver le locataire en cours.',
	confirmClearTenant: 'Confirmation de l\'effacement du locataire',
	currentValues: 'Valeurs en cours',
	emptyPromptValues: 'Aucune valeur n\'existe actuellement',
	editValues: 'Editer des valeurs',
	clear: 'Effacer',
	source: 'Source',
	dataRefreshed: 'Données actualisées',
	//PDF options
	pdfOptions: 'Options PDF',
	set: 'Définir',
	portrait: 'Portrait',
	landscape: 'Paysage',
	letter: 'Lettre',
	legal: 'Juridique',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Orientation',
	pageDefination: 'Taille du papier',
	openPasswordRequired: 'Demander un mot de passe pour ouvrir un rapport',
	accessPasswordRequired: 'Demander un mot de passe pour accéder au rapport',
	emptyPassword: 'Le mot de passe ne peut pas être vide',
	password: 'Mot de passe',
	enterPassword: 'Entrer un mot de passe',
	confirmPassword: 'Confirmation du mot de passe',
	passwordMatchError: 'Les mots de passe ne correspondent pas',
	gateway: 'Passerelle',
	pageLayout: 'Mise en page',
	pageStyle: 'Style',
	setUrl: 'Définir l\'URL',
	numberRows: 'Nombre de lignes',
	numberColumns: 'Nombre de colonnes',
	timeToRefresh: 'Durée de l\'actualisation',
	lastRefreshedBy: 'Actualisé par',
	unknown: 'Inconnu',
	unknownUpdateError: 'La mise à jour de l\'élément a échoué. Pour obtenir de l\'aide supplémentaire, contactez votre administrateur.',
	editQuery: 'Editer une requête',
	greaterOrEqual: 'Supérieur ou égal à %{upperboundValue}',
	lessOrEqual: 'Inférieur ou égal à %{lowerboundValue}'
});
